import React, { useEffect, useState } from 'react'

export default function ModalMudanca() {
  const [modalVisible, setModalVisible] = useState(false)

  useEffect(() => {
    const test = localStorage.getItem('viuModalMudanca')
    if (!test) {
      setModalVisible(true)
    }
  }, [])

  const handleClose = () => {
    localStorage.setItem('viuModalMudanca', 'true')
    setModalVisible(false)
  }

  if (!modalVisible) return null

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-5"
      onClick={handleClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white dark:bg-neutral-800 w-full rounded-none shadow-lg p-6 animate-[fadeIn_.2s_ease-out] max-w-md border-2 border-border dark:border-neutral-700"
      >
        <div className="flex items-start gap-3 mb-4">
          <div className="bg-primary/10 text-primary rounded-none w-10 h-10 flex items-center justify-center font-bold border-2 border-primary">
            !
          </div>
          <div>
            <h1 className="text-lg font-semibold text-foreground dark:text-neutral-100 leading-tight text-start">
              Atualizamos o sistema de login
            </h1>
            <p className="text-sm text-muted-foreground dark:text-neutral-400 mt-1 text-start">
              Agora o acesso é feito pelo número de telefone.
            </p>
          </div>
        </div>

        <p className="text-sm text-muted-foreground dark:text-neutral-400 leading-relaxed text-start">
          Essa mudança deixa o processo mais rápido e seguro. Ainda estamos ajustando
          detalhes para deixar o NovusCFC cada vez melhor.
        </p>

        <div className="mt-6 flex justify-end">
          <button
            onClick={handleClose}
            className="bg-primary text-white px-5 py-2 rounded-none font-semibold hover:opacity-90 active:scale-95 transition-all border-2 border-primary"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  )
}
